module.exports = __webpack_public_path__ + "media/images/amex-260bfb4cf3437974d9c8a2dfaf67d26a.svg";